import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-700d7085"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-busy"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_error_message = _resolveComponent("error-message")!
  const _component_link_back = _resolveComponent("link-back")!

  return (_openBlock(), _createElementBlock("div", {
    class: "loading-container col-12 px-0",
    "aria-live": "polite",
    "aria-busy": _ctx.state === 'loading'
  }, [
    (_ctx.state === 'loading')
      ? (_openBlock(), _createBlock(_component_loader, {
          key: 0,
          i18nMessage: _ctx.i18nLoadingMessage
        }, null, 8, ["i18nMessage"]))
      : _createCommentVNode("", true),
    (_ctx.state === 'error')
      ? (_openBlock(), _createBlock(_component_error_message, {
          key: 1,
          i18nMessage: _ctx.i18nErrorMessage,
          class: "mt-2"
        }, null, 8, ["i18nMessage"]))
      : _createCommentVNode("", true),
    (_ctx.state === 'error' && _ctx.errorLinkTo)
      ? (_openBlock(), _createBlock(_component_link_back, {
          key: 2,
          to: _ctx.errorLinkTo,
          i18nMessage: _ctx.i18nErrorLinkMessage,
          class: "mt-2"
        }, null, 8, ["to", "i18nMessage"]))
      : _createCommentVNode("", true),
    (_ctx.state === 'success')
      ? _renderSlot(_ctx.$slots, "default", { key: 3 }, undefined, true)
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}